@if (show) {
  <div class="error-text" style="text-align: center; padding: 2em; margin: 1em; border: 4px dashed; font-size: 17px">
    {{ 'browser-clock-check.browser-time-wrong' | translate | async }}<br /><br />
    {{ 'browser-clock-check.current-time' | translate | async }}{{ serverTime | ltimestamptime | async }}.<br /><br />
    {{ 'browser-clock-check.browser-time' | translate | async }}{{ browserTime | ltimestamptime | async }}.<br /><br />
  </div>
}
